<div class="load-panel-container">
  <div class="load-panel">
    <app-load-indicator class="load-indicator"></app-load-indicator>
    <div class="message">{{languageService.LNG("Label.ProcessingPleaseWait")}}...</div>
  </div>
</div>
